import { ImportError } from 'interfaces/api_import.interfaces';


export function isHeaderProblem( error: ImportError | undefined ): boolean {
  return error?.err === 155;
}